import { array } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button from 'ravenjs/lib/Button';
import Divider from 'ravenjs/lib/Divider';
import { genID } from 'ravenjs/utils/generate';

const SidebarPaginatorWrapper = styled.div`
    bottom: 0;
    display: flex;
    flex-direction: column;
    padding: 10px 0 15px 0;
    ${({ theme }) => theme.media.down('md')`
        position: relative;
        width: 100%;
    `};
    ${({ theme }) => theme.media.up('md')`
        position: absolute;
        width: 240px;
    `};
`;

const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const SidebarPaginator = props => {
    const { config } = props;

    return (
        <SidebarPaginatorWrapper>
            <Divider color="muted" />
            <ButtonsWrapper>
                {config.map(conf => (
                    <Button
                        key={genID()}
                        width="110px"
                        style={{ minWidth: '110px' }}
                        color={conf.color}
                        onClick={conf.onClick}
                        disabled={conf.disabled}
                    >
                        {conf.text}
                    </Button>
                ))}
            </ButtonsWrapper>
        </SidebarPaginatorWrapper>
    );
};

SidebarPaginator.propTypes = {
    config: array,
};

SidebarPaginator.defaultProps = {
    config: [],
};

export default SidebarPaginator;
